import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
    AppIcons,
    AppIconPack,
    DefaultIcons,
    DefaultIconPack
} from '../icons';

Vue.use(Vuetify);

Vue.component('font-awesome-icon', FontAwesomeIcon);

library.add(
    AppIconPack,
    DefaultIconPack
);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#2CADBF'
            }
        }
    },
    icons: {
        iconfont: 'faSvg',
        values: {
            ...AppIcons,
            ...DefaultIcons
        }
    }
});
